import { AbstractControl, ValidationErrors } from '@angular/forms';
import { assign, isEmpty, isNil, omit } from 'lodash';

import { GenericObject } from '../interfaces/generic-object';

export function percentOwnerValidator(
  percentOwnerFormControl: AbstractControl<any>
): ValidationErrors | null {
  const percentOwner = percentOwnerFormControl.value;

  if (!isNil(percentOwner) && (percentOwner < 15 || percentOwner > 100)) {
    const errors: GenericObject = {};
    if (percentOwner < 15) {
      percentOwnerFormControl.setErrors(
        assign(percentOwnerFormControl.errors || {}, {
          percentOwnerTooLittle: true
        })
      );
      Object.assign(errors, { percentOwnerTooLittle: true });
    }

    if (percentOwner > 100) {
      percentOwnerFormControl.setErrors(
        assign(percentOwnerFormControl.errors || {}, {
          percentOwnerTooMuch: true
        })
      );
      Object.assign(errors, { percentOwnerTooLittle: true });
    }

    return errors;
  } else {
    if (percentOwnerFormControl.errors) {
      percentOwnerFormControl.setErrors(
        isEmpty(omit(percentOwnerFormControl.errors, ['percentOwner']))
          ? null
          : percentOwnerFormControl.errors
      );
    }
    return null;
  }
}
